import React from 'react';

const Thankyou = () => {
    return(
        <h1>Thankyou</h1>
    );
}

export default Thankyou;